import { Stack, Typography } from '@mui/material'
import ArrowRightNewSvg from '~/@ui/_sharedSvgs/ui/ArrowRightNew.svg?react'
import SavingsSvg from '~/@ui/_sharedSvgs/ui/Savings.svg?react'
import ChairSvg from '~/@ui/_sharedSvgs/ui/Chair.svg?react'
import HeartSvg from '~/@ui/_sharedSvgs/ui/Heart.svg?react'
import { useNavigate } from 'react-router-dom'
import { IInvestmentOrder } from '~/@api/generated-api-types/global.types'
import { LoadingWheelOrange } from '~/@ui/info-card/LoadingWheels/LoadingWheelOrange'
import { LoadingWheelPurple } from '~/@ui/info-card/LoadingWheels/LoadingWheelPurple'

type Props = {
  investment: IInvestmentOrder
  className?: string
}

export const InvestmentCard = ({ investment, className = '' }: Props) => {
  const navigate = useNavigate()

  const isCreated = investment.status === 'created'
  const isPairing = investment.status === 'pairing'

  return (
    <Stack
      className={`${className}`}
      onClick={() => {
        navigate(`/investor/portfolio/investments/${investment.publicId}`)
      }}>
      <Stack className="p-4 bg-zGrey200 rounded-t-4d">
        <Stack className="flex-row items-center gap-2">
          {investment.investmentProductId === '689078f3aa0d380fd9f50a05' && (
            <SavingsSvg />
          )}
          {investment.investmentProductId === '689078f3aa0d380fd9f509ff' && (
            <ChairSvg />
          )}
          {investment.investmentProductId === '689078f2aa0d380fd9f509e8' && (
            <HeartSvg />
          )}
          <Typography className="flex-1 text-lg font-semibold text-zBlack200">
            {investment.productSnapshot.name}
          </Typography>
          <ArrowRightNewSvg />
        </Stack>

        <Stack className="pt-6">
          <Typography className="text-xs font-medium text-zGrey400">
            {`ID investície: ${investment.publicId}`}
          </Typography>
          <Stack className="flex-row justify-between pt-2.5">
            <Typography className="text-3d font-medium text-zGrey300">
              Mesačná investícia
            </Typography>
            <Typography className="text-base font-bold text-zBlack200 tabular-nums">
              {`${investment.monthlyInvestmentAmount} €`}
            </Typography>
          </Stack>
          <Stack className="flex-row justify-between  pt-2">
            <Typography className="text-3d font-medium text-zGrey300">
              Investované
            </Typography>
            <Typography className="text-base font-bold text-zBlack200 tabular-nums">
              {`${Math.floor(investment.totalInvestedAmount).toLocaleString('sk-SK')} €`}
            </Typography>
          </Stack>
          <Stack className="flex-row justify-between  pt-2">
            <Typography className="text-3d font-medium text-zGrey300">
              Hodnota investície
            </Typography>
            <Typography className="text-base font-bold text-zBlack200 tabular-nums">
              {`${Math.floor(investment.totalReturnedAmount).toLocaleString('sk-SK')} €`}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Stack
        className={`
        flex-row gap-2 p-4 rounded-b-4d
        ${isCreated && 'bg-[#FFE4DB]'}
        ${isPairing && 'bg-[#DED4FF]'}
      `}>
        {isCreated && <LoadingWheelOrange className="flex-shrink-0 w-5 h-5" />}
        {isPairing && <LoadingWheelPurple className="flex-shrink-0 w-5 h-5" />}
        <Typography className="text-3d font-bold text-zBlack200">
          {isCreated && 'Čakáme na platbu'}
          {isPairing && 'Párovanie so seniorom'}
        </Typography>
      </Stack>
    </Stack>
  )
}
